import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { DELIVERY_COMPANIES, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';

import DeliveryCompanyForm from './DeliveryCompanyForm';

/**
 * @author @s-uzgor
 *
 */
const DeliveryCompanies = () => {
	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 50 },
			{
				Header: 'name',
				accessor: 'name',
				filterType: FilterType.string,
				renderCell: ListComponents.DELIVERY_COMPANY_LOGO,
				width: 80,
				showOnMobile: true
			},
			{
				Header: 'rating',
				accessor: 'rating',
				filterType: FilterType.number,
				width: 50,
				showOnMobile: true
			},
			{
				Header: 'dailyCapacity',
				accessor: 'dailyCapacity',
				filterType: FilterType.number,
				width: 50,
				showOnMobile: true
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.multiSelection,
				width: 50
			},
			{
				Header: 'statusIntegrationName',
				accessor: 'statusIntegrationName',
				filterType: FilterType.multiSelection,
				width: 50
			},
			{
				Header: 'shippingReturnCost',
				accessor: 'shippingReturnCost',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'companyType',
				accessor: 'companyType',
				filterType: FilterType.multiSelection,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enum,
				enumName: ENUMS.ACTIVE_PASSIVE,
				width: 50,
				showOnMobile: true
			},
			{
				Header: 'trackingURL',
				accessor: 'trackingURL',
				filterType: FilterType.string,
				width: 50,
				show: false
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reasonConfig-icon.json.gz"
				title="deliveryCompanies">
				<Button
					icon={faPlus}
					label="addDeliveryCompany"
					onClick={() => NiceModal.show(DeliveryCompanyForm, { mode: 'add' })}
					variant="blackOutline"
				/>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.DELIVERY_COMPANIES}
				columns={columns}
				defaultFilters={filtersFromRouter}
				fetchUrl={DELIVERY_COMPANIES.GET_DELIVERY_COMPANIES_LIST}
				exportName="DeliveryCompaniesListExport"
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
				defaultSort={defaultSort}
			/>
		</TabTableContainer>
	);
};

export default DeliveryCompanies;
